<template>
    <div class="map-container">
        <!-- 头部 -->
        <div id="map" ref="mapContainer"></div>
    </div>
</template>

<script>
import { initMap, addMarker, updateMarker, searchRoute } from '@/js/amap';
import { VehicleWebSocket } from '@/js/websocket';
import busIconImg from '../../img/bus-icon.png';
export default {
    name: 'MapContainer',
    props: {
        shouldUpdateRoute: Boolean,
        vehicleGidList: {
            type: String,
            required: true
        },
        vehiclePosition: {
            type: Object,
            default: () => ({ lng: 0, lat: 0 })
        },
        selfPosition: {
            type: Object,
            default: () => ({ lng: 0, lat: 0 })
        }
    },
    data() {
        return {
            map: null,
            AMap: null,
            drivingService: null,
            vehicleMarker: null,
            selfMarker: null,
            routeInfo: null,
            ws: null,
            vehicleInfo: null,
            isFirstIn: true,
            vehicleNewPosition: null
        };
    },
    watch: {
        shouldUpdateRoute(newVal) {
            if (newVal) {
                this.searchDrivingRoute(this.vehicleNewPosition, true);
            }
        },
        // 当vehicleGId变化时重新连接WebSocket
        vehicleGidList(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.reconnectWebSocket();
            }
        }
    },
    async mounted() {
        const { map, AMap, drivingService } = await initMap('map');
        this.map = map;
        this.AMap = AMap;
        this.drivingService = drivingService;
        this.isFirstIn = true;
        // 初始化标记
        // this.vehicleMarker = addMarker(map, [this.vehiclePosition.lng, this.vehiclePosition.lat], {
        //     content: '<div class="vehicle-marker"></div>',
        //     offset: new AMap.Pixel(-10, -10)
        // });

        this.selfMarker = addMarker(map, [this.selfPosition.lng, this.selfPosition.lat], {
            content: '<p class="self-marker"></p>',
            offset: new AMap.Pixel(-10, -10)
        });
        this.map.setFitView();
        // 连接WebSocket获取车辆位置
        this.connectWebSocket();

        // 获取自身位置
        //this.getSelfPosition();
    },
    methods: {
        centerOnVehicle() {
            if (this.vehicleMarker && this.map) {
                this.map.setCenter(this.vehicleMarker.getPosition());
                this.map.setZoom(15);
            }
        },

        highlightVehicle(highlight) {
            if (this.vehicleMarker) {
                const content = this.vehicleMarker.getContent();
                if (content) {
                    content.classList.toggle('highlight', highlight);
                }
            }
        },

        createVehicleMarker(position, plateNumber, direction) {
            // 创建自定义标记内容
            const markerContent = document.createElement('div');
            markerContent.className = 'vehicle-marker-container';

            // 大巴车图标
            const busIcon = document.createElement('div');
            busIcon.className = 'bus-icon';
            busIcon.style.transform = `rotate(${direction}deg)`;
            Object.assign(busIcon.style, {
                width: '40px',
                height: '40px',
                backgroundImage: `url(${busIconImg})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                transform: `rotate(${direction}deg)`,
                transition: 'transform 0.3s ease',
                position: 'relative',
                zIndex: 10
            });
            // 车牌号标签
            // const plateLabel = document.createElement('div');
            // plateLabel.className = 'plate-number';
            // plateLabel.textContent = plateNumber;

            markerContent.appendChild(busIcon);
            //markerContent.appendChild(plateLabel);

            // 创建高德地图标记
            return new this.AMap.Marker({
                position,
                content: markerContent,
                offset: new this.AMap.Pixel(-20, -20),  // 根据图标大小调整
                zIndex: 100
            });
        },

        updateVehicleMarker(marker, newPosition, newDirection) {
            // 更新位置
            marker.setPosition(newPosition);

            // 更新方向
            const content = marker.getContent();
            if (content && content.querySelector) {
                const busIcon = content.querySelector('.bus-icon');
                if (busIcon) {
                    busIcon.style.transform = `rotate(${newDirection}deg)`;
                }
            }
        },

        reconnectWebSocket() {
            if (this.ws) {
                this.ws.close();
            }
            this.connectWebSocket();
        },
        //调整车辆图标方向
        doDirectionToAngle(Direction) {
            var deg;
            switch (Direction) {
                case "东":
                    deg = 0;
                    break;
                case "东南":
                    deg = 45;
                    break;
                case "南":
                    deg = 90;
                    break;
                case "西南":
                    deg = 135;
                    break;
                case "西":
                    deg = 180;
                    break;
                case "西北":
                    deg = 225;
                    break;
                case "北":
                    deg = 275;
                    break;
                case "东北":
                    deg = 315;
                    break;
                default:
                    deg = 0;
                    break;
            }
            return deg;
        },
        connectWebSocket() {
            if (!window.WebSocket) {
                this.$dialog.alert({
                    title: "提示",
                    message: "您的浏览器不支持WebSocket，无法获取车辆位置。",
                });
                return;
            }
            var protocol = location.protocol === "https:" ? "wss:" : "ws:";
            const wsUrl = protocol +
                "//class.busboss.cn/api/gps?_Authorization=" +
                window.localStorage.getItem("_cyw_token");
            this.ws = new VehicleWebSocket(wsUrl, this.vehicleGidList, (data) => {
                console.log(data)
                if (data.success) {
                    this.vehicleInfo = data.data[0];
                    if (this.vehicleInfo.Time) {
                        let vehicleTime = this.$moment(this.vehicleInfo.Time); // 解析车辆时间
                        let currentTime = this.$moment(); // 当前时间

                        let diffMinutes = currentTime.diff(vehicleTime, 'minutes'); // 计算分钟差

                        if (Math.abs(diffMinutes) < 30) {
                            // 更新车辆位置
                            const newPosition = new this.AMap.LngLat(this.vehicleInfo.Lon, this.vehicleInfo.Lat);
                            this.vehicleNewPosition = newPosition
                            // 更新或创建标记
                            if (this.vehicleMarker) {
                                this.updateVehicleMarker(
                                    this.vehicleMarker,
                                    newPosition,
                                    this.doDirectionToAngle(this.vehicleInfo.Direction) || 0
                                );
                            } else {
                                this.vehicleMarker = this.createVehicleMarker(newPosition, this.vehicleInfo.VehicleNo, this.doDirectionToAngle(this.vehicleInfo.Direction));
                                this.vehicleMarker.setMap(this.map);
                            }
                            // 触发事件通知父组件
                            this.$emit('vehicle-position-updated', { lng: data.lng, lat: data.lat, vehicleGidList: this.vehicleGidList });
                            // 如果自身位置已知，规划路线
                            if (this.selfPosition.lng && this.selfPosition.lat && this.isFirstIn) {
                                this.searchDrivingRoute(newPosition, this.isFirstData);
                                this.isFirstIn = false;
                            }
                        }
                    }

                }

            });
        },

        getSelfPosition() {
            //使用站点坐标
            //this.selfPosition = { lng: this.nodeGeocoder.split(",")[0], lat: this.nodeGeocoder.split(",")[1] };

            // if (navigator.geolocation) {
            //     navigator.geolocation.watchPosition(
            //         (position) => {
            //             const newPosition = new this.AMap.LngLat(
            //                 position.coords.longitude,
            //                 position.coords.latitude
            //             );

            //             updateMarker(this.selfMarker, newPosition);
            //             this.selfPosition = { lng: position.coords.longitude, lat: position.coords.latitude };

            //             //触发事件通知父组件
            //             this.$emit('self-position-updated', this.selfPosition);

            //             //如果车辆位置已知，规划路线
            //             if (this.vehicleMarker) {
            //                 const vehiclePos = this.vehicleMarker.getPosition();
            //                 this.searchDrivingRoute(vehiclePos);
            //             }
            //         },
            //         (error) => {
            //             console.error('获取位置失败:', error);
            //         },
            //         {
            //             enableHighAccuracy: true,
            //             maximumAge: 30000,
            //             timeout: 27000
            //         }
            //     );
            // }
        },

        searchDrivingRoute(vehiclePosition, isSetFitView) {
            const selfPos = this.selfMarker.getPosition();

            searchRoute(
                this.drivingService,
                vehiclePosition,
                selfPos,
                (error, result) => {
                    if (error) {
                        console.error('路线规划失败:', error);
                        this.$emit('route-error', error.message);
                        return;
                    }

                    // 解析路线信息
                    const route = result.routes[0];
                    const distance = route.distance; // 单位:米
                    const duration = Math.round(route.time / 60); // 转换为分钟
                    const vehicleNo = this.vehicleInfo.VehicleNo
                    this.routeInfo = {
                        vehicleNo,
                        distance,
                        duration
                    };

                    // 触发事件通知父组件
                    this.$emit('route-updated', {
                        distance,
                        duration,
                        vehicleNo
                    });
                    if (isSetFitView) {
                        // 调整地图视图以显示整个路线
                        this.map.setFitView();
                    }

                }
            );
        }
    },
    beforeDestroy() {
        if (this.ws) {
            this.ws.close();
        }
    }
};
</script>

<style>
.map-container {
    width: 100%;
    height: 100%;
}

#map {
    width: 100%;
    height: 100%;
}

.vehicle-marker {
    width: 20px;
    height: 20px;
    background-color: red;
    border-radius: 50%;
    border: 2px solid white;
}

.self-marker {
    width: 20px;
    height: 20px;
    background-color: green;
    border-radius: 50%;
    border: 2px solid white;
}

/* 全局标记样式 */
.vehicle-marker-container {
    position: relative;
    text-align: center;
}

.bus-icon {
    width: 40px;
    height: 40px;
    background-image: url('../../img/bus-icon.png');
    background-size: contain;
    background-repeat: no-repeat;
    margin: 0 auto;
    transition: transform 0.3s ease;
}

.plate-number {
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(255, 255, 255, 0.9);
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 12px;
    white-space: nowrap;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    border: 1px solid #ddd;
}

.vehicle-marker-container.highlight .bus-icon {
    background-image: url('../../img/bus-icon.png');
}

.vehicle-marker-container.highlight .plate-number {
    background-color: #ffeb3b;
    font-weight: bold;
}
</style>